const getters = {
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  sidebar: state => state.app.sidebar,
  roles: state => state.user.roles,
  name: state => state.user.name,
  menus: state => state.menu.menus,
  menusNewNum: state => state.menu.menusNewNum,
  currentMenu: state => state.menu.currentMenuID,
  permission_routes: state => state.permission.routes,
  // Ԥ���ƻ� ��
  isReported: state => state.preSalePlan.isReported,
  reportNum: state => state.preSalePlan.reportNum,
  storeId: state => state.preSalePlan.storeId,
  planTime: state => state.preSalePlan.planTime,
  timeTypeName: state => state.preSalePlan.timeType,
  //小件管理
  samllReportNum: state => state.smallPieceManagement.reportNum,
  smallPlanTime: state => state.smallPieceManagement.planTime,
  smallStoreId: state => state.smallPieceManagement.storeId,
  isStoreReported: state => state.smallPieceManagement.isStoreReported,
  isAllStoresReported: state => state.smallPieceManagement.isAllStoresReported,
  smallIsAllReported: state => state.smallPieceManagement.isAllReported,
  isStoreCanReported: state => state.smallPieceManagement.isStoreCanReported,
  //小家电管理
  smallHomeReportNum: state => state.smallHomeAppliances.reportNum,
  smallHomePlanTime: state => state.smallHomeAppliances.planTime,
  smallHomeStoreId: state => state.smallHomeAppliances.storeId,
  smallHomeIsStoreReported: state => state.smallHomeAppliances.isStoreReported,
  smallHomeIsAllStoresReported: state => state.smallHomeAppliances.isAllStoresReported,
  smallHomeIsAllReported: state => state.smallHomeAppliances.isAllReported,
  smallHomeIsStoreCanReported: state => state.smallHomeAppliances.isStoreCanReported,

  isAllReported: state => state.preSalePlan.isAllReported,
  // ��������
  global_outOfStockRecordsData: state => state.operateAnalysis.global_outOfStockRecordsData
}
export default getters
